import i18next from 'i18next';

export const getCountryName = (countryKey: string) => {
  return i18next.t(countryKey, { lng: 'en', ns: 'countries' });
};

export const getCountryNameTranslation = (countryKey: string) => {
  return i18next.t(countryKey, { ns: 'countries' });
};
